export enum PurchaseReceiptsLabels {
  Nfe = 'Nota Fiscal Eletrônica',
  Sale = 'Recibo',
  Ticket = 'Boleto',
  Invoice = 'Fatura',
  Billet = 'Declaração de matrícula',
}

export enum PurchaseReceiptsTypes {
  Nfe = 'nfe',
  Sale = 'sale',
  Ticket = 'ticket',
  Invoice = 'invoice',
  Billet = 'billet',
}

export enum PaymentReceiptsLabels {
  Payment = 'Fatura de cartão de crédito',
  BillingStatement = 'Comprovante de débito',
}

export enum PaymentReceiptsTypes {
  Payment = 'payment',
  BillingStatement = 'billing_statement',
  Other = 'other',
}

export enum TypeOfBankTransfer {
  Pix = 'pix',
  Ted = 'ted',
}

export enum PixKeyType {
  Cpf = 'cpf',
  Email = 'email',
  Phone = 'phone',
  Random = 'random',
}

export enum PixKeyLabel {
  Cpf = 'CPF',
  Email = 'E-mail',
  Phone = 'Telefone',
  Random = 'Chave aleatória',
}

export enum OtherReceiptsLabels {
  Other = 'Outro',
}

export type ReceiptType = PurchaseReceiptsTypes | PaymentReceiptsTypes;

export const ReceiptTypeLabels: Record<ReceiptType, string> = {
  [PurchaseReceiptsTypes.Nfe]: PurchaseReceiptsLabels.Nfe,
  [PurchaseReceiptsTypes.Sale]: PurchaseReceiptsLabels.Sale,
  [PurchaseReceiptsTypes.Ticket]: PurchaseReceiptsLabels.Ticket,
  [PurchaseReceiptsTypes.Invoice]: PurchaseReceiptsLabels.Invoice,
  [PurchaseReceiptsTypes.Billet]: PurchaseReceiptsLabels.Billet,
  [PaymentReceiptsTypes.Payment]: PaymentReceiptsLabels.Payment,
  [PaymentReceiptsTypes.BillingStatement]:
    PaymentReceiptsLabels.BillingStatement,
  [PaymentReceiptsTypes.Other]: OtherReceiptsLabels.Other,
};

export enum Months {
  January = 'Janeiro',
  February = 'Fevereiro',
  March = 'Março',
  April = 'Abril',
  May = 'Maio',
  June = 'Junho',
  July = 'Julho',
  August = 'Agosto',
  September = 'Setembro',
  October = 'Outubro',
  November = 'Novembro',
  December = 'Dezembro',
}
